import { withInstall, withNoopInstall } from '@jdesign-vue/utils'

import Descriptions from './src/description.vue'
import DescriptionsItem from './src/description-item'

export const JdDescriptions = withInstall(Descriptions, {
  DescriptionsItem,
})

export const JdDescriptionsItem = withNoopInstall(DescriptionsItem)

export default JdDescriptions

export * from './src/description'
